import React, { useEffect } from "react";
import { ExplorerWordmark, Space, Typography } from "@murm/ant";
import apiClient from "../lib/axios";
import styles from "./StatusPages.module.css";

const { Title, Text } = Typography;

const HealthPage = () => {
  useEffect(() => {
    const checkServerHealth = async () => {
      try {
        const response = await apiClient.get("/api/health");
        console.log("Server is healthy", response);
      } catch (error) {
        console.log("Server is not healthy", error);
      }
    };

    checkServerHealth();
  }, []);

  return (
    <Space
      direction="vertical"
      size="large"
      align="center"
      className={styles.health}
    >
      <ExplorerWordmark size="hero" />
      <Title level={3} className={styles.flush}>
        I am alive
      </Title>
      <Text type="secondary">Health check page</Text>
    </Space>
  );
};

export { HealthPage };
